export class CstAddressEntity{
    custAddrSeq :string;
    custId : string;
    portfolioId: number;
}